import { useReduxOrg } from '@Hooks/reduxOrgHook/useReduxOrg';
import { AlertTriangle, Mail } from 'lucide-react';
import './SubscriptionExpiredPage.scss';

export default function SubscriptionExpiredPage() {

    const { currentOrg } = useReduxOrg();
    const className = 'subscriptionExpiredPage';

    return (
        <div className={className}>
            <div className={className + '__card'}>
                <div className={className + '__icon'}>
                    <AlertTriangle size={48} />
                </div>

                <h2 className={className + '__title'}>Subscription Inactive</h2>

                <p className={className + '__message'}>
                    The subscription for{' '}
                    <strong>{currentOrg?.orgName || 'your organization'}</strong>{' '}
                    is currently inactive or has expired.
                </p>

                <p className={className + '__contact'}>
                    Please contact your organization administrator to renew the subscription and restore access.
                </p>

                {currentOrg?.orgName && (
                    <div className={className + '__org'}>
                        <span className={className + '__org__label'}>Organization</span>
                        <span className={className + '__org__name'}>{currentOrg.orgName}</span>
                        {currentOrg.tag && (
                            <span className={className + '__org__tag'}>{currentOrg.tag}</span>
                        )}
                    </div>
                )}

                <div className={className + '__hint'}>
                    <Mail size={14} />
                    <span>Reach out to your admin to get access restored.</span>
                </div>
            </div>
        </div>
    );
}
